import ApiServiceBase from "../ApiServiceBase";
import ApiService from "../ApiService";
import { ServiceType } from "../ServiceType.data";
import { GstinValidityResponse } from "./GstinValidityService.type";

const service: ApiServiceBase = new ApiService(ServiceType.Account, true);

class GstinValidityService {
  public checkGstinValid(
    gstin: string
  ): GstinValidityResponse | Promise<GstinValidityResponse> {
    return service.post(
      { route: ["check-gstin-status"] },
      { gstin: gstin.toUpperCase() }
    );
  }

  public checkGstinRegisterable(gstin: string) {
    return service.post(
      { route: ["validate-gstin/customer-portal"] },
      { gstin: gstin.toUpperCase() }
    );
  }
}

const gstinValidityService = new GstinValidityService();
export default gstinValidityService;
